import React from "react";
import Icon from "../../components/ui/Icon/Icon";
import styles from "./style.module.css";
import { useTranslation } from "react-i18next";

const SuccessSection = ({
  title,
  descriptionLine1,
  descriptionLine2,
  onNext,
  confirmButtonText,
  icon = <Icon size={72} name="ico-email" />,
}) => {
  const { t } = useTranslation("payment");

  return (
    <section className={styles.successContainer}>
      <div className={styles.successContent}>
        {icon}

        <h2 className={styles.successTitle}>{title}</h2>

        <p className={styles.successMessage}>
          {descriptionLine1}
          <br />
          {descriptionLine2}
        </p>

        <button className={styles.successButton} onClick={onNext}>
          {confirmButtonText || t("confirmButtonText")}
        </button>
      </div>
    </section>
  );
};

export default SuccessSection;
